export const REMEMBER_LOGIN = 'REMEMBER_LOGIN';
